import {twMerge} from 'tailwind-merge'

const mergeTw = twMerge
export default mergeTw
